import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class FaviconService {
  faviconStatus: string;

  constructor() {}

  faviconChange(type: string | null = null) {
    let favicon_name: string | null = null;
    switch (type) {
      case 'danger':
      case 'error':
        favicon_name = 'favicon_red.ico';
        this.faviconStatus = 'error';
        break;
      case 'info':
        favicon_name = 'favicon_blue.ico';
        this.faviconStatus = 'info';
        break;
      case 'success':
        favicon_name = 'favicon_green.ico';
        this.faviconStatus = 'success';
        break;
      case 'warning':
        favicon_name = 'favicon_yellow.ico';
        this.faviconStatus = 'warning';
        break;
      case null:
        favicon_name = 'favicon.ico';
        this.faviconStatus = '';
        break;
      default:
        favicon_name = `favicon_${type}.ico`;
        this.faviconStatus = type;
    }
    let link: any = document.querySelector("link[rel*='icon']") || document.createElement('link');
    link.type = 'image/x-icon';
    link.rel = 'shortcut icon';
    link.href = `/${favicon_name}`;
    document.getElementsByTagName('head')[0].appendChild(link);
  }
}
